import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import { AdminRoutes } from './admin-routes';
import LicenseError from './error/license-error';
import { Profile } from './profile/profile.component';
import { ReleaseNotesRoutes } from './release-notes/release-notes-routes';
import Unauthorized from './unauthorized/unauthorized';

const StockOverviewReport = lazy(() => import('./stock/stock-overview-report/stock-overview-report'));
const MovementOverviewReport = lazy(() => import('./movement/movement-overview-report/movement-overview-report'));
const ChangePassword = lazy(() => import('./authentication/change-password/change-password.component'));

export function AppRoutes() {
    const adminRoutes = AdminRoutes();
    const releaseNotesRoutes = ReleaseNotesRoutes();

    return (
        <Routes>
            {releaseNotesRoutes}
            {adminRoutes}

            <Route path='warehouse'>
                <Route
                    path='inventory'
                    element={
                        <AsyncComponent>
                            <StockOverviewReport />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='history'
                    element={
                        <AsyncComponent>
                            <MovementOverviewReport />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route path='change-password'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <ChangePassword />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route path='profile'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <Profile />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route
                path='missing-license'
                element={<LicenseError />}
            />
            <Route
                path='unauthorized'
                element={<Unauthorized />}
            />
        </Routes>
    );
}

export default AppRoutes;
